/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { action, observable, makeObservable } from 'mobx';

const DEFAULT_STATE = {
  isDialogVisible: false,
  dialogProps: {}
};

class ConfirmActionStore {
  promise = null;

  state = Object.assign(DEFAULT_STATE);

  constructor() {
    makeObservable(this, {
      state: observable,
      cancel: action,
      accept: action,
      confirm: action
    });
  }

  cancel = () => {
    this.state.isDialogVisible = false;
    this.resolve(false);
  };

  accept = () => {
    this.state.isDialogVisible = false;
    this.resolve(true);
  };

  async confirm(dialogProps) {
    this.promise = new Promise((resolve) => {
      this.resolve = resolve;
    });

    this.state.dialogProps = dialogProps;
    this.state.isDialogVisible = true;

    return this.promise;
  }
}

export default new ConfirmActionStore();
